export enum StoreActions {
    SET_CREDENTIALS = "setSpotifyCredentials",
    UPDATE_TOKENS = "updateSpotifyTokens",
    CLEAR_CREDENTIALS = "clearSpotifyCredentials",
}
